import {
  REMOVE_CUSTOMER_TAG,
  REMOVE_CUSTOMER_TAG_SUCCESS,
  REMOVE_CUSTOMER_TAG_FAIL,
} from "./actionTypes";

const initialState = {
  error: null,
  message: null,
  loading: false,
};

const removeCustomerTag = (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_CUSTOMER_TAG:
    case REMOVE_CUSTOMER_TAG_SUCCESS:
    case REMOVE_CUSTOMER_TAG_FAIL:
      state = {
        ...state,
        ...action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default removeCustomerTag;
